import * as ActionTypes from '../actions/queueActions';

export const queue = (
  state = {
    variantTickets: [],
    pinTickets: [],
    pinTicketsMayHaveMore: false,
    pinTicketsMayBeIncomplete: false,
    pinSearchRequiresUsername: false
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.GET_VARIANTS_QUEUE_SUCCESS:
      return {
        ...state,
        variantTickets: action.variants
      };

    case ActionTypes.GET_PINS_QUEUE_SUCCESS:
      return {
        ...state,
        pinTickets: action.pins,
        pinTicketsMayHaveMore: action.fetchedCount >= ActionTypes.PINS_QUEUE_PAGE_SIZE,
        pinTicketsMayBeIncomplete: action.resultsMayBeIncomplete,
        pinSearchRequiresUsername: action.searchRequiresUsername
      };

    case ActionTypes.REMOVE_PIN_FROM_QUEUE:
      return {
        ...state,
        pinTickets: state.pinTickets.filter(pin => pin.id !== action.Pin_id)
      };

    default:
      return state;
  }
};
